import React from 'react';

const WhatIsASI1 = () => {
  return (
    <section className="mb-16">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">What is ASI1?</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <p className="text-gray-700 leading-relaxed mb-4">
            ASI1 LLM represents a significant advancement as the world's first Web3-native Large Language Model (LLM) designed specifically for agentic AI. Unlike general-purpose LLMs, ASI1 LLM is optimized for the complex interactions and autonomous decision-making required by Agents operating within a decentralized environment.
          </p>
          <p className="text-gray-700 leading-relaxed">
            This allows for nuanced understanding, context-aware responses, and secure operation within the Web3 ecosystem. Its integration with the ASI wallet, powered by the FET token, further strengthens its connection to the decentralized world, enabling seamless and secure transactions and interactions within the ASI network.
          </p>
        </div>
        <div>
          <p className="text-gray-700 leading-relaxed mb-4">
            A key innovation of ASI1 family of LLMs lies in its advanced reasoning capabilities, enabling next-level adaptive reasoning and context-aware decision-making. This focus on agentic AI allows it to excel at complex tasks requiring autonomous operation.
          </p>
          <p className="text-gray-700 leading-relaxed">
            This heralds a new era of intelligent applications within Web3, paving the way for advancements in areas like DeFi, supply chain management, and personalized AI assistants, unlocking the potential of autonomous agents operating within a decentralized framework.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatIsASI1;
